import { api } from "../../api/apiSlice";

const userApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserProfile: builder.query({
      query: () => "/user/profile",
      providesTags: ["profileUpdate"],
    }),
    getUsers: builder.query({
      query: () => "/user",
      providesTags: ["profileUpdate", "user"],
    }),
    updateUserProfile: builder.mutation({
      query: ({ id, data }) => ({
        url: `/user/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["profileUpdate"],
    }),
    getUserAddress: builder.query({
      query: () => "/address",
      providesTags: ["user"],
    }),
    addUserAddress: builder.mutation({
      query: (data) => ({
        url: `/address`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["user"],
    }),
    deleteUserAddress: builder.mutation({
      query: (id) => ({
        url: `/address/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["user"],
    }),
    updateUserAddress: builder.mutation({
      query: ({ id, data }) => ({
        url: `/address/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["user"],
    }),
    addToWishlist: builder.mutation({
      query: ({ data }) => ({
        url: `/user/addwishlist`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["profileUpdate"],
    }),
    removeFromWishList: builder.mutation({
      query: ({ data }) => ({
        url: `/user/removewishlist`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["profileUpdate"],
    }),
    blockUser: builder.mutation({
      query: (id) => ({
        url: `/user/block/${id}`,
        method: "PATCH",
      }),
    }),
    unblockUser: builder.mutation({
      query: (id) => ({
        url: `/user/unblock/${id}`,
        method: "PATCH",
      }),
    }),
    deleteUser: builder.mutation({
      query: (id) => ({
        url: `/user/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["user"],
    }),
  }),
});

export const {
  useGetUserProfileQuery,
  useGetUserAddressQuery,
  useAddUserAddressMutation,
  useDeleteUserAddressMutation,
  useUpdateUserAddressMutation,
  useUpdateUserProfileMutation,
  useGetUsersQuery,
  useBlockUserMutation,
  useUnblockUserMutation,
  useDeleteUserMutation,
  useAddToWishlistMutation,
  useRemoveFromWishListMutation,
} = userApi;
